import React from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { useRccTypography } from "./typography";
import { rccColors } from "./colors";

const useStyles = makeStyles((theme) => ({
  navBar: {
    display: "flex",
    padding: "8px",
    alignItems: "flex-start",
    gap: "10px",
    alignSelf: "stretch",
    borderRadius: "8px",
    backgroundColor: rccColors.neutral[50],
  },
  navBarContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flex: "1 0 0",
  },
  dashboardLabelContainer: {
    display: "flex",
    padding: "8px 12px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "4px",
    background: "#FFF",
  },
  dateContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
  },
  calendarIcon: {
    color: rccColors.blue[800],
    width: "14px",
    height: "16px",
    aspectRatio: "7/8",
    fontSize: "16px",
  },
}));

function RccNavigationBar({ dashboardLabel = "Executive Dashboard" }) {
  const classes = useStyles();
  const typography = useRccTypography();
  const user = useSelector((state) => state.app?.user);

  // Get currentFiscalQuarter from user, format as "YYYY-QN QTD", fallback to default
  const dateText = user?.currentFiscalQuarter
    ? `${user.currentFiscalQuarter} QTD`
    : "Current Fiscal Quarter";

  return (
    <Box className={classes.navBar}>
      <Box className={classes.navBarContainer}>
        <Box className={classes.dashboardLabelContainer}>
          <Typography
            className={typography.textMediumSemibold}
            style={{ color: rccColors.blue[700] }}
          >
            {dashboardLabel}
          </Typography>
        </Box>
        <Box className={classes.dateContainer}>
          <i className={`material-icons ${classes.calendarIcon}`}>
            calendar_month
          </i>
          <Typography
            className={typography.textMediumMedium}
            style={{ color: rccColors.neutral[500] }}
          >
            {dateText}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default RccNavigationBar;
